import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class NgxToastrServiceService {

  constructor(private toastr: ToastrService) { }

  showSuccessToast(msgBody?: string, msgTitle?: string, showCloseBtn?: boolean, showHtml?: boolean, customTimeOut?: number, customExtendedTimeOut?: number, showProgressBar?: boolean) {
    this.toastr.success(msgBody, msgTitle, {
      closeButton: (showCloseBtn !== null && showCloseBtn !== undefined) ? showCloseBtn : false,
      enableHtml: (showHtml !== null && showHtml !== undefined) ? showHtml : false,
      timeOut: (customTimeOut !== null && customTimeOut !== undefined) ? customTimeOut : 2000,
      extendedTimeOut: (customExtendedTimeOut !== null && customExtendedTimeOut !== undefined) ? customExtendedTimeOut : 500,
      progressBar: (showProgressBar !== null && showProgressBar !== undefined) ? showProgressBar : false,
    });
    this.toastr.toastrConfig.autoDismiss = true;
    this.toastr.toastrConfig.maxOpened = 1;
    this.toastr.toastrConfig.preventDuplicates = true;
  }

  showErrorToast(msgBody?: string, msgTitle?: string, showCloseBtn?: boolean, showHtml?: boolean, customTimeOut?: number, customExtendedTimeOut?: number, showProgressBar?: boolean) {
    this.toastr.error(msgBody, msgTitle, {
      closeButton: (showCloseBtn !== null && showCloseBtn !== undefined) ? showCloseBtn : false,
      enableHtml: (showHtml !== null && showHtml !== undefined) ? showHtml : false,
      timeOut: (customTimeOut !== null && customTimeOut !== undefined) ? customTimeOut : 5000,
      extendedTimeOut: (customExtendedTimeOut !== null && customExtendedTimeOut !== undefined) ? customExtendedTimeOut : 1000,
      progressBar: (showProgressBar !== null && showProgressBar !== undefined) ? showProgressBar : false,
    });
    this.toastr.toastrConfig.autoDismiss = true;
    this.toastr.toastrConfig.maxOpened = 1;
    this.toastr.toastrConfig.preventDuplicates = true;
  }

  showInfoToast(msgBody?: string, msgTitle?: string, showCloseBtn?: boolean, showHtml?: boolean, customTimeOut?: number, customExtendedTimeOut?: number, showProgressBar?: boolean) {
    this.toastr.info(msgBody, msgTitle, {
      closeButton: (showCloseBtn !== null && showCloseBtn !== undefined) ? showCloseBtn : false,
      enableHtml: (showHtml !== null && showHtml !== undefined) ? showHtml : false,
      timeOut: (customTimeOut !== null && customTimeOut !== undefined) ? customTimeOut : 5000,
      extendedTimeOut: (customExtendedTimeOut !== null && customExtendedTimeOut !== undefined) ? customExtendedTimeOut : 1000,
      progressBar: (showProgressBar !== null && showProgressBar !== undefined) ? showProgressBar : false
    });
    this.toastr.toastrConfig.autoDismiss = true;
    this.toastr.toastrConfig.maxOpened = 1;
    this.toastr.toastrConfig.preventDuplicates = true;
  }

  showWarningToast(msgBody?: string, msgTitle?: string, showCloseBtn?: boolean, showHtml?: boolean, customTimeOut?: number, customExtendedTimeOut?: number, showProgressBar?: boolean) {
    this.toastr.warning(msgBody, msgTitle, {
      closeButton: (showCloseBtn !== null && showCloseBtn !== undefined) ? showCloseBtn : false,
      enableHtml: (showHtml !== null && showHtml !== undefined) ? showHtml : false,
      timeOut: (customTimeOut !== null && customTimeOut !== undefined) ? customTimeOut : 5000,
      extendedTimeOut: (customExtendedTimeOut !== null && customExtendedTimeOut !== undefined) ? customExtendedTimeOut : 1000,
      progressBar: (showProgressBar !== null && showProgressBar !== undefined) ? showProgressBar : false
    });
    this.toastr.toastrConfig.autoDismiss = true;
    this.toastr.toastrConfig.maxOpened = 1;
    this.toastr.toastrConfig.preventDuplicates = true;
  }

  showToast(msgBody?: string, msgTitle?: string, showCloseBtn?: boolean, showHtml?: boolean, customTimeOut?: number, customExtendedTimeOut?: number, showProgressBar?: boolean) {
    this.toastr.show(msgBody, msgTitle, {
      closeButton: (showCloseBtn !== null && showCloseBtn !== undefined) ? showCloseBtn : false,
      enableHtml: (showHtml !== null && showHtml !== undefined) ? showHtml : false,
      timeOut: (customTimeOut !== null && customTimeOut !== undefined) ? customTimeOut : 5000,
      extendedTimeOut: (customExtendedTimeOut !== null && customExtendedTimeOut !== undefined) ? customExtendedTimeOut : 1000,
      progressBar: (showProgressBar !== null && showProgressBar !== undefined) ? showProgressBar : false
    });
    this.toastr.toastrConfig.autoDismiss = true;
    this.toastr.toastrConfig.maxOpened = 1;
    this.toastr.toastrConfig.preventDuplicates = true;
  }
}
